
import React, { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';

const counterData = [
    { number: 987, suffix: '+', title: 'Happy Clients', label: 'Athletes coached with structured online support.' },
    { number: 10000, suffix: '+', title: 'Exercises', label: 'Movements, drills, and progressions across the platform.' },
    { number: 789, suffix: '+', title: 'Online Sessions', label: 'Completed coaching sessions and guided video lessons.' },
];

const CounterBlog = () => {
    const gridRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const grid = gridRef.current;

        if (!grid) {
            return undefined;
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReducedMotion) {
            setIsVisible(true);
            return undefined;
        }

        if (!('IntersectionObserver' in window)) {
            setIsVisible(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.24 },
        );

        observer.observe(grid);

        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={gridRef}
            className={`counter-blog-grid${isVisible ? ' is-visible' : ''}`}
        >
            {counterData.map((item, ind) => (
                <article className="counter-blog-card" key={item.title}>
                    <span className="counter-blog-index">{String(ind + 1).padStart(2, '0')}</span>
                    <div className="counter-blog-content">
                        <h3 className="title counter">
                            <CountUp
                                start={0}
                                end={item.number}
                                duration={2.8}
                                enableScrollSpy
                                scrollSpyOnce
                                separator=","
                            />
                            {item.suffix}
                        </h3>
                        <p className="counter-blog-title">{item.title}</p>
                        <p className="counter-blog-label">{item.label}</p>
                    </div>
                </article>
            ))}
        </div>
    );
};

export default CounterBlog;
